
import { Component, Vue } from 'vue-property-decorator'
import NewsTicker from '~/components/common/NewsTicker.vue'

@Component({
  name: 'Subheader',
  components: {
    NewsTicker
  }
})
export default class Subheader extends Vue {
  //
}
